export const LOCAL_STORAGE = {
  AUTH_TOKEN: "auth_token",
  CLIENT_SOURCE: "client_source",
  MODE: "mode",
  USER_INFO: "user_info",
  QUERY_PARAMS: "query_params",
  THEME_COLORS: "theme_colors",
};

export const constants = {
  ERROR_MESSAGES: {
    SOMETHING_WENT_WRONG: "Something went wrong!",
  },
  SEARCH_FOOD_ITEM_TITLE: {
    SEARCH_RESULT: "Search Result",
    RECENT_SEARCH: "Recent Search",
  },
};

export const DOCUMENT_REVIEW_STATUS = {
  UNDER_REVIEW: "Under Review",
  REJECTED: "Rejected",
  APPROVED: "Approved",
};

export const POST_MESSAGE_EVENTS = {
  SHOW_MENU_DRAWER: "SHOW_MENU_DRAWER",
  NAVIGATE_TO_NOTIFICATIONS: "NAVIGATE_TO_NOTIFICATIONS",
  NAVIGATE_TO_WEBVIEW: "NAVIGATE_TO_WEBVIEW",
  SHARE_RECORD_DOCUMENT: "SHARE_RECORD_DOCUMENT",
  OPEN_EXTERNAL_LINK: "OPEN_EXTERNAL_LINK",
  LOGOUT: "LOGOUT",
};

export const APP_LINKS = {
  TERMS_AND_CONDITIONS: "https://shop.goodflip.in/pages/terms-conditions",
  PRIVACY_POLICY: "https://shop.goodflip.in/pages/privacy-policy",
  HEALTH_STORE_LINK: "https://shop.goodflip.in",
};

export const CHART_TIME_LABELS = [
  "08:00 PM",
  "04:00 PM",
  "12:00 PM",
  "08:00 AM",
  "04:00 AM",
  "12:00 AM",
];

export const paymentModes = ["card", "upi", "netbanking", "manual", "free"];
export const paymentStatus = ["pending", "success", "failed"];

export const transactionTypes = ["payment", "refund"];
export const transactionStatuses = [
  "created",
  "processing",
  "success",
  "failed",
];

export const genderOptions = [
  {
    label: "Male",
    value: "male",
  },
  {
    label: "Female",
    value: "female",
  },
];

export const tenantRoleOptions = [
  {
    label: "Admin",
    value: "admin",
  },
  {
    label: "Manager",
    value: "manager",
  },
  {
    label: "Staff",
    value: "staff",
  },
];
